import React from 'react';
import Layout from '../../components/layout/Layout';
import ResetPasswordForm from '../../components/ResetPasswordForm';

import './resetPassword.scss';

export default function () {
    const { match } = this.props;
    const { isValidResetPassword, isSucessResetPassword, isFetching } = this.props;
    const { token } = match.params;

    return (
        <Layout 
            className="login" 
            title="reset-password" 
            isVisibleHeader={false} 
            showFooter={false}
            loading={isFetching}
        >
            <ResetPasswordForm 
                token={token} 
                isValidResetPassword={isValidResetPassword} 
                isSucessResetPassword={isSucessResetPassword} 
            />
        </Layout>
    );


}
